import { render, staticRenderFns } from "./CookieInformation.vue?vue&type=template&id=2d57ad98"
import script from "./CookieInformation.vue?vue&type=script&lang=js"
export * from "./CookieInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports